// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dPNQynBgDZ4u6a8P4TsB{margin-top:20px}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/dropdown/floor-detail/floor-detail-home.module.scss"],"names":[],"mappings":"AAAA,sBACC,eAAA","sourcesContent":[".tabSwitcher {\n\tmargin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export var tabSwitcher = `dPNQynBgDZ4u6a8P4TsB`;
export default ___CSS_LOADER_EXPORT___;
